import { HttpClient } from '../HttpClient';
/**
 * * Get Employee Information
 */
export const GetEmployeeSingle = async (id, includes) => {
  try {
    const { data } = await HttpClient.get(`/api/employees/${id}`, {
      params: {
        include: includes,
      },
    });

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
